<template>
  <div>
    <div v-if="dataloaded == false" class="blackbox-loader"></div>

    <div v-if="dataloaded == true">

      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex md3 xs6>
            <v-card class="usertype-total" outlined>
              <div class="usertype-total-number">{{ filteredUsersSuperadmins }}</div>
              <div class="usertype-total-desc">
                <span v-if="filteredUsersSuperadmins == 1">Superadmin</span>
                <span v-else>Superadmins</span>
              </div>
            </v-card>
          </v-flex>
          <v-flex md3 xs6>
            <v-card class="usertype-total" outlined>
              <div class="usertype-total-number">{{ filteredUsersAdmins }}</div>
              <div class="usertype-total-desc">
                <span v-if="filteredUsersAdmins == 1">Admin</span>
                <span v-else>Admins</span>
              </div>
            </v-card>
          </v-flex>
          <v-flex md3 xs6>
            <v-card class="usertype-total" outlined>
              <div class="usertype-total-number">{{ filteredUsersManagers }}</div>
              <div class="usertype-total-desc">
                <span v-if="filteredUsersManagers== 1">Manager</span>
                <span v-else>Managers</span>
              </div>
            </v-card>
          </v-flex>
          <v-flex md3 xs6>
            <v-card class="usertype-total" outlined>
              <div class="usertype-total-number">{{ filteredUsersEmployees }}</div>
              <div class="usertype-total-desc">
                <span v-if="filteredUsersEmployees == 1">Medewerkers</span>
                <span v-else>Medewerkers</span>
              </div>
            </v-card>
          </v-flex>

          <v-flex xs12> 
            <v-card outlined>
              <v-card-title>
                <v-text-field
                  style="max-width: 300px;"
                  v-model="search"
                  :color="companyPrimaryColor"
                  placeholder="Zoeken"
                  outlined
                  hide-details     
                  :background-color="$vuetify.theme.themes[theme].background"                                                   
                  prepend-inner-icon="search"
                  autocomplete="disabled"
                  clearable>
                </v-text-field>
                <v-spacer></v-spacer>
                <div class="header-edit-button">
                  <v-btn class="mx-2" fab dark :color="companySecondaryColor" @click="exportToCsv()">
                    <v-icon dark>mdi-download</v-icon>
                  </v-btn>
                  <v-btn class="mx-2" fab dark :color="companyPrimaryColor" @click.stop="newUserDialog = true">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                  <v-btn class="mx-2" fab dark :color="companySecondaryColor" v-if="selected.length > 0" @click="deleteUser()">
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                  
                </div>
              </v-card-title>

              <v-data-table
                :headers="headers"
                :items="filteredUsers"
                v-model="selected"
                :itemsPerPage.sync="userPages"
                hide-default-footer
                show-select
                
                class="users-table"
                >
                <template v-slot:item="{item, isSelected, select }">
                  <tr>
                    <td>
                      <v-icon @click="select(true)" v-if="!isSelected">check_box_outline_blank</v-icon>
                      <v-icon @click="select(false)" v-if="isSelected" :color="companyPrimaryColor">check_box</v-icon>
                    </td>
                    <td>
                      <v-icon small :color="activeColor(item.active)">radio_button_unchecked</v-icon>
                    </td> 
                    <td>{{ item.firstName }} {{ item.lastName }}</td>
                    <td>
                      <span v-for="company in companies" :key="company.id">
                        <div  v-if="company.id == item.company" >{{ company.name }}</div>
                      </span>
                    </td>
                    <td>{{ item.email }}</td>
                    <td>
                      <span v-for="userRole in userRoles" :key="userRole.id">
                        <div  v-if="userRole.id == item.userRole" >{{ userRole.name }}</div>
                      </span>
                    </td>
                    <td style="padding-top: 5px; padding-bottom: 5px;">
                      <span v-for="company in companies" :key="company.id">
                        <span v-for="linkedComp in item.accessCompanies" :key="linkedComp">
                          <div  v-if="company.id == linkedComp" >&#8226; {{ company.name }}</div>
                        </span>  
                      </span>
                    </td>
                    <td>
                      <v-btn style="float: right;" icon class="mx-0" @click.stop="seeUserLog(item)">
                        <v-icon small :color="$vuetify.theme.themes[theme].text">notes</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-btn style="float: right;" icon class="mx-0" @click="editUser(item)">
                        <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>

        </v-layout>
      </v-container>
    </div>

    <!-- / New User Dialog \ -->
    <v-dialog value="true" v-model="newUserDialog" scrollable max-width="600px">
      <add-user-form :formType="'superadmin'" :showDialog="newUserDialog" :userRoles="userRoles" :companies="companies" @newUserDialogChange="newUserDialog = $event" @updateData="loadUsers()"></add-user-form>
    </v-dialog>
    <!-- \ New User Dialog / -->

    <!-- / Edit User Dialog \ -->
    <v-dialog v-model="editUserDialog" scrollable max-width="600px">
      <edit-user-form :formType="'superadmin'" :showEditDialog="editUserDialog" :userRoles="userRoles" :companies="companies" :userFormInfoOriginal="editUserInfoOriginal" :userFormInfo="editUserInfo" @userEditDialogChange="editUserDialog = $event" @updateData="loadUsers()"></edit-user-form>
    </v-dialog>
    <!-- \ Edit User Dialog / -->

    <!-- / Edit User Dialog \ -->
    <v-dialog v-model="userLogsDialog" scrollable max-width="800px">
      <view-user-logs :selectedUserCompany="selectedUserCompany" @viewUserLogsDialogChange="userLogsDialog = $event" ></view-user-logs>
    </v-dialog>
    <!-- \ Edit User Dialog / -->

  </div>
</template>


<script>
// import firebase from "firebase/app";;
import db from "../firebase/init";
import _ from "lodash";
import AddUserForm from "../components/modals/AddUserForm.vue";
import EditUserForm from "../components/modals/EditUserForm.vue";
import ViewUserLogs from "../components/modals/ViewUserLogs.vue";
import { bus } from "../main";
import axios from 'axios';

export default {
  components: {
    "add-user-form": AddUserForm,
    "edit-user-form": EditUserForm,
    "view-user-logs": ViewUserLogs
  },
  name: "users",

  data: () => ({
    search: "",
    userPages: -1,
    userLogsDialog:  false,
    selectedUserCompany: null,
    dataloaded: false,
    editUserDialog: false,
    newUserDialog: false,
    editUserInfoOriginal: {
      accessCompanies: [],
      company: "",
      firstName: "",
      lastName: "",
      id: "",
      userRole: "",
      user_id: ""
    },
    editUserInfo: {
      accessCompanies: [],
      company: "",
      firstName: "",
      lastName: "",
      id: "",
      userRole: "",
      user_id: ""
    },
    pagination: {
      rowsPerPage: "1000",
      sortBy: "lastName",
      descending: true
    },
    removeBookings: "",
    selected: [],
    companies: [],
    users: [],
    userRoles: [
      {
        name: "Super Admin",
        id: "superadmin"
      },
      {
        name: "Admin",
        id: "admin"
      },
      {
        name: "Manager",
        id: "manager"
      },
      {
        name: "Medewerker",
        id: "employee"
      }
    ],
    headers: [
      {
        text: "",
        value: "active",
        width: "30px"
      },
      {
        text: "Naam",
        align: "left",
        value: "firstName",
        width: "200px"
      },
      {
        text: "Aansluiting",
        align: "left",
        value: "companies"
      },
      {
        text: "E-mail",
        align: "left",
        value: "email"
      },
      {
        text: "Type",
        align: "left",
        value: "userRole"
      },
      
      {
        text: "Toegang",
        align: "left",
        value: "companies"
      },
      {
        text: "",
        align: "right",
        value: "edit",
        width: "30px"
      },
      {
        text: "",
        align: "right",
        value: "edit",
        width: "30px"
      }
    ]
  }),

  created() {
    this.loadCompanies();
    this.loadUsers();
  },

  methods: {
    loadCompanies() {
      db.collection("companies")
        .get()
        .then(snap => {
          this.companies = [];
          snap.forEach(doc => {
            let compCollection = {};
            compCollection.name = doc.data().name;
            compCollection.id = doc.id;
            this.companies.push(compCollection);
          });
        })
        .catch(error => {
          console.error("Error loading companies: ", error);
        });
    },
    closeUserDialog() {
      this.newUserDialog = false;
      this.editUserDialog = false;
      // this.$emit('resetForm');
    },

    editUser(item) {
      this.editUserDialog = true;
      this.editedIndex = this.users.indexOf(item);
      this.editUserInfo = _.cloneDeep(item);
      this.editUserInfoOriginal = _.cloneDeep(item);
      setTimeout(()=>{
        bus.$emit("getCompanyBranches", this.editUserInfo.company);
      }, 100)
      
    },

    seeUserLog(item){ 
      console.log("seeUserLog: ", item)
      this.companies.forEach(company =>{
        if(item.company == company.id){
          this.selectedUserCompany = company.name
        }
      }) 
      
      let username = item.firstName + " " + item.lastName
      this.userLogsDialog = true
      setTimeout(()=>{
        bus.$emit("getUserLogs", username);
      }, 100)
    },

    async exportToCsv(){
      const { Parser } = require("json2csv");
      const fields = [
        {
          label: 'Voornaam',
          value: 'firstName'
        },
        {
          label: 'Achternaam',
          value: 'lastName'
        },
        {
          label: 'Bedrijf',
          value: 'company'
        },
        {
          label: 'Email',
          value: 'email'
        },
        {
          label: 'Actief',
          value: 'active'
        }
      ];
      const json2csvParser = new Parser({ fields, delimiter: ";" });
      const productsCSV = json2csvParser.parse(this.users);

      console.log("exportToCsv");
      let csvContent = "data:text/csv;charset=utf-8," + productsCSV;
      var encodedUri = encodeURI(csvContent); 
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "4care-gebruikers.csv");
      document.body.appendChild(link); 
      link.click();
    },

    deleteUser() {
      this.selected.forEach(element => {
        db.collection("users")
          .doc(element.id)
          .delete()
          .then(() => {
            var config = {
              method: 'post',
              url: 'https://europe-west1-call-traffic-data.cloudfunctions.net/auth',
              headers: { 
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
              },
              data : {
                type: 'deleteUser',
                uid: element.user_id
              }
            };
            axios(config)
            // Log Action
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Gebruiker verwijderd",
              extra:
                "<b>Naam</b>: " +
                element.firstName +
                " " +
                element.lastName +
                "<br>" +
                "<b>Rol</b>: " +
                element.userRole +
                "<br>" +
                "<b>Email</b>: " +
                element.email +
                "<br>" +
                "<b>Aansluiting</b>: " +
                element.company +
                "<br>" +
                "<b>Toegang</b>: " +
                element.accessCompanies
            });
          })
          .then(() => {
            this.selected = [];
            console.log("User successfully deleted!");
            this.loadUsers();
          })
          .catch(error => {
            this.selected = [];
            console.error("Error removing user: ", error);
          });
      });
    },

    activeColor(type){
      if(type){
        return 'green'
      }
      else{
        return 'warning';
      }
    },

    loadUsers() {
      this.dataloaded = false
      db.collection("users").get()
        .then(snap => {
          this.users = [];
          snap.forEach(doc => {
            let userCollection = doc.data();
            userCollection.id = doc.id;
            this.users.push(userCollection);
          });
        })
        .then(()=>{
          this.dataloaded = true;
        })
        .catch(error => {
          console.error("Error loading user: ", error);
        });
    }
  },

  computed: {
    filteredUsers() {
      if(this.search){
        return this.users.filter(user => {
          return (
            user.firstName.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            user.lastName.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
        });
      }
      else{
        return this.users
      }
      
    },

    filteredUsersSuperadmins() {
      let counter = 0
      this.filteredUsers.forEach(user =>{
        if(user.userRole == 'superadmin'){
          counter++
        }
      })
      return counter
    },
    filteredUsersAdmins() {
      let counter = 0
      this.filteredUsers.forEach(user =>{
        if(user.userRole == 'admin'){
          counter++
        }
      })
      return counter
    },

    filteredUsersManagers() {
      let counter = 0
      this.filteredUsers.forEach(user =>{
        if(user.userRole == 'manager'){
          counter++
        }
      })
      return counter
    },

    filteredUsersEmployees() {
      let counter = 0
      this.filteredUsers.forEach(user =>{
        if(user.userRole == 'employee'){
          counter++
        }
      })
      return counter
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>

<style>
/*
<v-card class="usertype-total">
  <div class="usertype-total-number">{{ filteredUsersSuperadmins }}</div>
  <div class="usertype-total-desc">
    <span v-if="filteredUsersSuperadmins == 1">Superadmin</span>
    <span v-else>Superadmins</span>
  </div>
</v-card>
  */


.usertype-total{
  padding: 10px;
}

.usertype-total-number{
  text-align: center;
  font-size: 38px;
}
.usertype-total-desc{
  text-align: center;
  font-size: 16px;
}


.users-table table.v-table thead td:not(:nth-child(1)), 
.users-table table.v-table tbody td:not(:nth-child(1)), 
.users-table table.v-table thead th:not(:nth-child(1)), 
.users-table table.v-table tbody th:not(:nth-child(1)), 
.users-table table.v-table thead td:first-child, 
.users-table table.v-table tbody td:first-child, 
.users-table table.v-table thead th:first-child, 
.users-table table.v-table tbody th:first-child {
  padding: 0 12px;
  
}
.users-table td{
  font-size: 12px!important;
}
</style>

